import React from "react";
import ExcelContainer from '../../Containers/ExcelContainer';


const ExcelList = (props) => {
	return (
		<ExcelContainer page="excelList"/>
	);
}

export default ExcelList;